import "./Cartagena.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ExclusiveExperiences from "./sections/ExclusiveExperiences";
import SignaturePartnerships from "./sections/SignaturePartnerships";
import BookYourLuxuryExperience from "./sections/BookYourLuxuryExperience";
import Footer from "@/reusable_sections/Footer";
export default function CartagenaPage() {
  return <div>
      <Header />
      <Hero />
      <ExclusiveExperiences />
      <SignaturePartnerships />
      <BookYourLuxuryExperience />
      <Footer />
    </div>;
}